import React, { useEffect } from "react";
import * as echarts from "echarts";

const MonthWisePWITOHOGraph2 = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedFy,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const calcTotal = (data, section, key) =>
    selectedMonths.reduce((sum, month) => {
      const m = data.find((o) => o.month.slice(0, 3) === month);
      return sum + Number(getSectionData(m, section)[key] || 0);
    }, 0);

  useEffect(() => {
    if (!selectedMonths.length || !selectedSections.length) return;

    const chart = echarts.init(document.getElementById("pwiChart2"));

    const sectionData = selectedSections
      .map((section) => {
        const prevTO = calcTotal(sortedPrev, section, "to_value");
        const currTO = calcTotal(sortedCurr, section, "to_value");

        return {
          section,
          prevTO,
          currTO,

          total: prevTO + currTO,
        };
      })
      .sort((a, b) => b.total - a.total);
    const label = {
      show: true,
      position: "top",
      rotate: 55,
      fontSize: 12,
      verticalAlign: "middle",
    };
    const option = {
      title: {
        text: `T/O – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: { trigger: "axis" },
      legend: { top: 30 },
      xAxis: {
        type: "category",
        data: sectionData.map((d) => d.section),
      },
      yAxis: { type: "value" },
      series: [
        {
          name: "T/O (Prev)",
          type: "bar",
          data: sectionData.map((d) => d.prevTO),
          label: label,
        },
        {
          name: "T/O (Curr)",
          type: "bar",
          data: sectionData.map((d) => d.currTO),
          label: label,
        },
      ],
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr, selectedFy]);

  return (
    <div className="papaDiv">
      <div
        id="pwiChart2"
        style={{ width: "100%", height: "50vh", marginTop: "30px" }}
      />
    </div>
  );
};

export default MonthWisePWITOHOGraph2;
